import { render, staticRenderFns } from "./ConfigureCustomAndroid.vue?vue&type=template&id=636d37cf&scoped=true"
import script from "./ConfigureCustomAndroid.vue?vue&type=script&lang=js"
export * from "./ConfigureCustomAndroid.vue?vue&type=script&lang=js"
import style0 from "./ConfigureCustomAndroid.vue?vue&type=style&index=0&id=636d37cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636d37cf",
  null
  
)

export default component.exports